import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  Container, Row, Col, Card, CardBody, Spinner,
  Modal, ModalHeader, ModalBody, ModalFooter,
  FormGroup, FormFeedback, Label, Input, Button,
} from 'reactstrap'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import Select from '../../components/Template/Input/Select'
import {MaterialReactTable} from 'material-react-table'
import { MRT_Localization_PT } from 'material-react-table/locales/pt'
import Edit from '@material-ui/icons/Edit'
import Delete from '@material-ui/icons/Delete'
import IconButton from '@mui/material/IconButton'
import { AttachFile, Description } from '@material-ui/icons'
import Box from '@mui/material/Box'
import { getRegs, selectValues, insOrUp, del, getOikosId, getReg, sendMail, getDocs, updateField } from '../../utils/fc'
import AddFiles from '../../components/Template/Files/AddFiles'
import oikosApi from '../../services/oikos'
import { notifySuccess, notifyError } from '../../utils/notify'
import DocTab from '../../components/Template/Doc/DocTab'
import Switch from '@mui/material/Switch'
import { abrirVagaInhireParaPedidoCompra } from '../../components/Modals/ModalPedidoCompra/usePedidoCompraEquipeActions'
import { resolveDocumentosObrigatoriosLabelsFromTpDocumento } from '../../components/Modals/ModalFormContrForn/contrFornExtendedFields'
import { applyContrFornApprovalTaskOutcome } from '../../components/Modals/ModalFormContrForn/applyContrFornApprovalTaskOutcome'
import { restaurarContratoPaiDoAditivo } from '../MeusFornecedores/aditarContrForn'
import {
  TAB_REF_DATA_LIMITE,
  PF_APROVADOR_DATA_LIMITE,
  aplicarDataLimiteAprovada,
  enviarEmailConclusaoDataLimite,
} from '../../utils/alteracaoDataLimite'

const TASK_MOTHER_FIELDS = {
  '(SELECT task_desc FROM task t1 WHERE t1.task_id = task.task_mae)': 'task_desc',
  '(SELECT task_prazo FROM task t1 WHERE t1.task_id = task.task_mae)': 'task_prazo',
  '(SELECT dpto_id FROM task t1 WHERE t1.task_id = task.task_mae)': 'dpto_id',
  '(SELECT taskTp_id FROM task t1 WHERE t1.task_id = task.task_mae)': 'taskTp_id',
  '(SELECT task_orientacao FROM task t1 WHERE t1.task_id = task.task_mae)': 'task_orientacao',
  '(SELECT task_comentario FROM task t1 WHERE t1.task_id = task.task_mae)': 'task_comentario',
}

const TASK_LIST_FIELDS_DATA1 = {
  '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = task.pf_id)': 'pf_nome',
  '(SELECT taskStatus_desc FROM taskStatus WHERE taskStatus.taskStatus_id = task.taskStatus_id)': 'taskStatus_desc',
  '(SELECT taskTp_desc FROM taskTp WHERE taskTp.taskTp_id = task.taskTp_id)': 'taskTp_desc',
  ...TASK_MOTHER_FIELDS,
}

const TASK_LIST_FIELDS_DATA2 = {
  '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = task.pf_id)': 'pf_nome',
  '(SELECT taskStatus_desc FROM taskStatus WHERE taskStatus.taskStatus_id = task.taskStatus_id)': 'taskStatus_desc',
  ...TASK_MOTHER_FIELDS,
}

class Task extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsOpen: false,
      modalIsSaving: false,
      modalData: {},
      dataIsLoading: false,
      data1: false,
      data2: false,
      selPf: false,
      selTaskStatus: false,
      selTaskTp: false,
      selProj: false,
      selDpto: false,
      oikos_id: false,
      switchProj: false,
      pedidoCompraTaskDetails: null,
      isLoadingPedidoCompraTaskDetails: false,
      taskAttachmentsLoading: false,
    }

    this.filesRef = React.createRef()
    this.taskFileRef = React.createRef()
  }

  componentDidMount() {
    this.preloading()
  }

  resolveTaskReference = async (taskData = {}) => {
    if (taskData.task_tabRef && taskData.task_tabId) {
      return {
        task_tabRef: taskData.task_tabRef,
        task_tabId: taskData.task_tabId,
      }
    }

    if (!taskData.task_mae) return null

    const parentTask = await getReg('task', taskData.task_mae)
    if (!parentTask?.task_tabRef || !parentTask?.task_tabId) return null

    return {
      task_tabRef: parentTask.task_tabRef,
      task_tabId: parentTask.task_tabId,
    }
  }

  fetchPedidoCompraTaskDetails = async (taskData = {}) => {
    const taskReference = await this.resolveTaskReference(taskData)
    if ((taskReference?.task_tabRef || '').toLowerCase() !== 'pedidocompra') return null

    const pedidoCompraId = Number(taskReference.task_tabId) || 0
    if (!pedidoCompraId) return null

    const [pedidoCompra] = await getRegs(
      'pedidoCompra',
      { pedidoCompra_id: pedidoCompraId },
      {
        '(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = pedidoCompra.orcItem_id LIMIT 1)': 'orcItem_desc',
        '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = pedidoCompra.pf_id LIMIT 1)': 'pf_nomeExibicao',
        '(SELECT pedidoCompraStatus_nome FROM pedidoCompraStatus WHERE pedidoCompraStatus.pedidoCompraStatus_id = pedidoCompra.pedidoCompraStatus_id LIMIT 1)': 'pedidoCompraStatus_nome',
        '(SELECT compraStatus_nome FROM compraStatus WHERE compraStatus.compraStatus_id = pedidoCompra.compraStatus_id LIMIT 1)': 'compraStatus_nome',
      }
    )
    const [vaga] = await getRegs(
      'vaga',
      { pedidoCompra_id: pedidoCompraId },
      {
        '(SELECT vagaStatus_nome FROM vagaStatus WHERE vagaStatus.vagaStatus_id = vaga.vagaStatus_id LIMIT 1)': 'vagaStatus_nome',
      }
    )
    const vagaDocumentosObrigatoriosLabel = vaga
      ? await this.resolveDocumentosObrigatoriosLabel(vaga.vaga_documentosObrigatorios)
      : null

    return {
      taskReference,
      pedidoCompra: pedidoCompra || null,
      vaga: vaga ? {
        ...vaga,
        vagaDocumentosObrigatoriosLabel,
      } : null,
    }
  }

  resolveDocumentosObrigatoriosLabel = async (value) => (
    resolveDocumentosObrigatoriosLabelsFromTpDocumento(value)
  )

  loadPedidoCompraTaskDetails = async (taskData = {}) => {
    const shouldTryLoad = taskData.task_tabRef || taskData.task_tabId || taskData.task_mae || [4, 5].includes(Number(taskData.taskTp_id))
    if (!shouldTryLoad) {
      this.setState({ pedidoCompraTaskDetails: null, isLoadingPedidoCompraTaskDetails: false })
      return
    }

    try {
      this.setState({ isLoadingPedidoCompraTaskDetails: true, pedidoCompraTaskDetails: null })
      const details = await this.fetchPedidoCompraTaskDetails(taskData)
      this.setState((prevState) => ({
        pedidoCompraTaskDetails: details,
        isLoadingPedidoCompraTaskDetails: false,
        modalData: details?.taskReference
          ? {
            ...prevState.modalData,
            task_tabRef: details.taskReference.task_tabRef,
            task_tabId: details.taskReference.task_tabId,
          }
          : prevState.modalData,
      }))
    } catch (e) {
      console.log('Erro ao carregar detalhes da cotação da tarefa:', e)
      this.setState({ pedidoCompraTaskDetails: null, isLoadingPedidoCompraTaskDetails: false })
    }
  }

  openTaskModal = (taskData = {}) => {
    this.setState(
      {
        modalData: {
          ...taskData,
        },
        modalIsOpen: true,
        pedidoCompraTaskDetails: null,
      },
      () => {
        this.loadPedidoCompraTaskDetails(taskData)
      }
    )
  }

  abrirVagaInhireParaPedidoCompraTask = async (taskData) => {
    console.log('taskData', taskData);

    if ((taskData?.task_tabRef || '').toLowerCase() !== 'pedidocompra') {
      notifyError('A tarefa não é uma cotação.')
      return
    }

    const createResponse = await abrirVagaInhireParaPedidoCompra(taskData.task_tabId)
    console.log('InHire vaga criada na aprovacao da tarefa:', createResponse)
  }

  collectTaskIdsForAttachments = (rows = []) => (
    [...new Set(
      rows.flatMap((row) => [row?.task_id, row?.task_mae].filter(Boolean)),
    )]
  )

  fetchTaskAttachmentsByTaskIds = async (rows = []) => {
    const taskIds = this.collectTaskIdsForAttachments(rows)
    if (!taskIds.length) return {}

    const vincs = await getRegs(
      'documentoVinc',
      {
        documentoVinc_tabRef: 'task',
        documentoVinc_tabId: `!IN!(${taskIds.join(',')})`,
      },
      {
        "(SELECT a.arquivo_caminho FROM arquivo a INNER JOIN documento d ON a.arquivo_tabId = d.documento_id WHERE d.documento_id = documentoVinc.documento_id AND a.arquivo_tabRef LIKE 'documento' AND d.documento_ativo = 1 AND a.arquivo_ativo = 1 ORDER BY a.arquivo_id DESC LIMIT 1)": 'arquivo_caminho',
        "(SELECT a.arquivo_id FROM arquivo a INNER JOIN documento d ON a.arquivo_tabId = d.documento_id WHERE d.documento_id = documentoVinc.documento_id AND a.arquivo_tabRef LIKE 'documento' AND d.documento_ativo = 1 AND a.arquivo_ativo = 1 ORDER BY a.arquivo_id DESC LIMIT 1)": 'arquivo_id',
      },
    )

    const attachByTaskId = {}
    ;(vincs || []).forEach((vinc) => {
      if (!vinc?.arquivo_caminho || !vinc?.documentoVinc_tabId) return
      const taskId = Number(vinc.documentoVinc_tabId)
      const arquivoId = Number(vinc.arquivo_id) || 0
      const prev = attachByTaskId[taskId]
      if (!prev || arquivoId > prev.arquivo_id) {
        attachByTaskId[taskId] = {
          arquivo_caminho: vinc.arquivo_caminho,
          arquivo_id: arquivoId,
        }
      }
    })

    return attachByTaskId
  }

  mergeTaskAttachments = (rows = [], attachByTaskId = {}) => (
    (rows || []).map((row) => {
      const candidates = []
      if (row?.task_id && attachByTaskId[row.task_id]) {
        candidates.push(attachByTaskId[row.task_id])
      }
      if (row?.task_mae && attachByTaskId[row.task_mae]) {
        candidates.push(attachByTaskId[row.task_mae])
      }
      const best = candidates.sort((a, b) => b.arquivo_id - a.arquivo_id)[0]
      return {
        ...row,
        task_attach: best?.arquivo_caminho || row.task_attach,
      }
    })
  )

  loadTaskListAttachments = async (data1, data2) => {
    const rows = [...(data1 || []), ...(data2 || [])]
    if (!rows.length) return

    this.setState({ taskAttachmentsLoading: true })
    try {
      const attachByTaskId = await this.fetchTaskAttachmentsByTaskIds(rows)
      this.setState((prevState) => ({
        data1: this.mergeTaskAttachments(prevState.data1, attachByTaskId),
        data2: this.mergeTaskAttachments(prevState.data2, attachByTaskId),
        taskAttachmentsLoading: false,
      }))
    } catch (e) {
      console.log('Erro ao carregar anexos das tarefas:', e)
      this.setState({ taskAttachmentsLoading: false })
    }
  }

  preloading = async() => {
    console.log('referência ao carregar: ', this.taskFileRef)
    this.setState({ dataIsLoading: true, taskAttachmentsLoading: false })

    const oikos_id = await getOikosId()
    const [data1, data2] = await Promise.all([
      getRegs('task', { pf_id: oikos_id }, TASK_LIST_FIELDS_DATA1),
      getRegs('task', { task_usuarioCria: oikos_id, task_mae: 'null' }, TASK_LIST_FIELDS_DATA2),
    ])

    console.log('callback de data1', data1)
    console.log('callback de data2', data2)

    this.setState({
      dataIsLoading: false,
      data1: data1 || [],
      data2: data2 || [],
      oikos_id,
      switchProj: false,
    })

    this.loadTaskListAttachments(data1, data2)

    const [selPf, selTaskStatus, selTaskTp, selProj, selDpto] = await Promise.all([
      selectValues('pf', 'pf_id', 'pf_nomeExibicao'),
      selectValues('taskStatus', 'taskStatus_id', 'taskStatus_desc'),
      selectValues('taskTp', 'taskTp_id', 'taskTp_desc'),
      selectValues('proj', 'proj_id', 'proj_nome'),
      selectValues('dpto', 'dpto_id', 'dpto_nome'),
    ])
    this.setState({ selPf, selTaskStatus, selTaskTp, selProj, selDpto })
  }

  handleTaskSubmit = async () => {
    const { modalData, switchProj } = this.state
    const pf_ids = modalData.pf_ids
    const taskMaeId = modalData.task_mae || null
    const taskComentario = (modalData.task_comentario || '').trim()
    const tabRefDataLimite = modalData.task_tabRef
    const orientacaoDataLimite = modalData.task_orientacao
    const statusDataLimite = Number(modalData.taskStatus_id)
    const ehConclusaoDataLimite = tabRefDataLimite === TAB_REF_DATA_LIMITE
      && modalData.task_id
      && (statusDataLimite === 2 || statusDataLimite === 4)
    try {
      this.setState({ modalIsSaving: true })
      if (ehConclusaoDataLimite && statusDataLimite === 2 && !taskComentario) {
        notifyError('Escreva um comentário para recusar a alteração da data.')
        this.setState((prev) => ({
          modalIsSaving: false,
          modalData: { ...prev.modalData, taskStatus_id: 1 },
        }))
        return
      }
      if (ehConclusaoDataLimite && statusDataLimite === 4) {
        try {
          this._resultadoDataLimite = await aplicarDataLimiteAprovada(orientacaoDataLimite)
        } catch (e) {
          notifyError(e?.message || 'Não foi possível aplicar a nova data.')
          this.setState((prev) => ({
            modalIsSaving: false,
            modalData: { ...prev.modalData, taskStatus_id: 1 },
          }))
          return
        }
      }
      console.log('modalData = ', modalData)
      delete modalData.pf_ids
      delete modalData.pf_nome
      delete modalData.taskStatus_desc
      delete modalData.taskTp_desc
      //delete modalData.task_usuarioMod
      delete modalData.task_mae
      delete modalData.item_id
      delete modalData.item_tabela
      delete modalData.task_irmas
      delete modalData.task_attach
      for (const key in modalData) {
        if (modalData[key] === null || modalData[key] === undefined) {
          delete modalData[key];
        }
      }

      let task_id
      // cadastra a tarefa principal
      if(modalData.task_id === null || modalData.task_id === undefined) {
        modalData.pf_id = modalData.task_usuarioCria // atribui a tarefa mãe ao próprio criador
        task_id = await insOrUp('task', modalData)
      } else {
        task_id = await insOrUp('task', modalData)
        if (!ehConclusaoDataLimite) {
          await this.mailNotification(modalData, task_id)
        }

        if (taskComentario && task_id) {
          await updateField('task', task_id, 'task_comentario', taskComentario)
          if (taskMaeId) {
            await updateField('task', taskMaeId, 'task_comentario', taskComentario)
          }
        }
        if (ehConclusaoDataLimite) {
          if (taskMaeId) {
            await updateField('task', taskMaeId, 'taskStatus_id', statusDataLimite)
          }
          try {
            await enviarEmailConclusaoDataLimite(
              orientacaoDataLimite,
              statusDataLimite === 4,
              taskComentario,
              this._resultadoDataLimite,
            )
          } catch (mailErr) {
            console.log('Falha ao enviar e-mail da data limite.', mailErr)
            notifyError('A decisão foi gravada, mas o e-mail de conclusão falhou.')
          }
        }
      }

      // cadastra uma subtarefa para cada item de modalData.pf_ids
      if(pf_ids)
        await Promise.all(
          pf_ids.map(async (i) => {
            const aux_modalData = { task_usuarioCria: modalData.task_usuarioCria, task_usuarioMod: modalData.task_usuarioCria, task_mae: task_id, pf_id: i.value, taskStatus_id: 1 }
            aux_modalData.task_desc = modalData.task_desc
            console.log('aux_modalData =', aux_modalData)
            const subtask_id = await insOrUp('task', aux_modalData)
            await this.mailNotification(aux_modalData, subtask_id)
            console.log('subtarefa cadastrada =', subtask_id)
          })
        )

      console.log('task id = ', task_id)
      const taskFile = this.taskFileRef?.current?.state?.files
      console.log('taskFile', taskFile)

      modalData.proj_id = switchProj ? modalData.proj_id : null

      // INÍCIO ANEXO DO ENUNCIADO DA TAREFA
      if (taskFile?.length > 0) {
        //cria o registro tarefa na tabela documento
        const documentBody = {
          action: 'insert',
          table: 'documento',
          data: {
            tpDocumento_id: taskFile[0].props?.documentType?.tpDocumento_id,
            documento_desc:  `${taskFile[0].props?.description}`,
            privacidade_id: 2,
          },
        }
        console.log('documentBody', documentBody)
        const documentCreated = await oikosApi.post('/', documentBody)
        console.log('documentCreated', documentCreated)

        //criar vinculação da tarefa
        if (documentCreated.data[0].documento_id) {
          const vinculationBody = {
            action: 'insert',
            table: 'documentoVinc',
            data: {
              documento_id: documentCreated.data[0].documento_id,
              documentoVinc_tabRef: 'task',
              documentoVinc_tabId: task_id,
            },
          }
          console.log('vinculationBody', vinculationBody)
          const vinculationCreated = await oikosApi.post('/', vinculationBody)
          console.log('vinculationCreated', vinculationCreated)
        }

        // Faz upload do arquivo da tarefa
        if (taskFile?.length > 0) {
          const formData = new FormData()
          formData.append('file', new Blob([taskFile[0].data], { type: taskFile[0].data.type }), taskFile[0].data.path)
          formData.append('table', 'arquivo')
          formData.append('action', 'upload_file')
          formData.append('arquivo_tabRef', 'documento')
          formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
          formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
          formData.append('arquivo_desc', taskFile[0].data.path)

          const res = await oikosApi.post('/', formData)
          console.tron.log('res upload_file', res)
        }
        // FIM DO ANEXO DO ENUNCIADO DA TAREFA
      }

      console.log('modalData.taskTp_id', modalData.taskTp_id)

      if(modalData.taskTp_id === 3) {
        if (modalData.taskStatus_id === 2) {
          const updateContrFornBody = {
            action: 'update',
            table: 'contrForn',
            data: {
              contrForn_id : modalData.task_tabId,
              contrFornStatus_id: 9
            }
          }

          await oikosApi.post('/', updateContrFornBody)
          await restaurarContratoPaiDoAditivo(modalData.task_tabId)
        } else if (modalData.taskStatus_id === 4) {
          const aditivoRes = await oikosApi.get('/?action=get&table=contrForn&data[contrForn_id]=' + modalData.task_tabId + '&fields[contrForn_original]=contrForn_original')
          if (Number(aditivoRes?.data?.[0]?.contrForn_original)) {
            await oikosApi.post('/', {
              action: 'update',
              table: 'contrForn',
              data: {
                contrForn_id: modalData.task_tabId,
                contrFornStatus_id: 7,
              },
            })
            notifySuccess('Aditivo aprovado. Anexe o documento assinado.')
          } else {
            await applyContrFornApprovalTaskOutcome(modalData.task_tabId)
          }
        }
      }

      if(modalData.taskTp_id === 4) {
        console.log(modalData);
        if (modalData.taskStatus_id === 2) {
          const updatePedidoCompraBody = {
            action: 'update',
            table: 'pedidoCompra',
            data: {
              pedidoCompra_id : modalData.task_tabId,
              pedidoCompraStatus_id: 6
            }
          }

          const res = await oikosApi.post('/', updatePedidoCompraBody);
          console.log('res updatePedidoCompraBody', res);
        } else if (modalData.taskStatus_id === 4) {
          const updatePedidoCompraBody = {
            action: 'update',
            table: 'pedidoCompra',
            data: {
              pedidoCompra_id : modalData.task_tabId,
              pedidoCompraStatus_id: 5
            }
          }

          const res = await oikosApi.post('/', updatePedidoCompraBody);
          await this.abrirVagaInhireParaPedidoCompraTask(modalData);
          console.log('res updatePedidoCompraBody', res);
        }
      }

      notifySuccess('Tarefa cadastrada com sucesso.')
      this.setState({
        dataIsLoadingIsLoading: false,
      })
      this.preloading()
      this.setState({ modalData: {}, modalIsOpen: false, modalIsSaving: false })

    } catch (e) {
      notifyError('Houve erro no cadastramento da tarefa.')
      console.log('Erro no cadastramento da tarefa.', e)
      this.setState({ modalIsSaving: false })
    }
  }

  handleTaskDelete = async (id) => {
    console.log('id da tarefa a ser excluída = ', id)
    try {
      del('task', id)
      notifySuccess('Tarefa excluída com sucesso com sucesso.')
      this.preloading()
      this.setState({ modalData: {}, modalIsOpen: false, modalIsSaving: false })
    } catch (e) {
      notifyError('Houve erro ao excluir a tarefa.')
      console.log('Erro ao excluir a tarefa.', e)
      this.setState({ modalIsSaving: false })
    }
  }



  toggleModal = () => {

    this.setState(prevState => ({
      modalIsOpen: !prevState.modalIsOpen,
      pedidoCompraTaskDetails: prevState.modalIsOpen ? null : prevState.pedidoCompraTaskDetails,
      isLoadingPedidoCompraTaskDetails: prevState.modalIsOpen ? false : prevState.isLoadingPedidoCompraTaskDetails,
    }))

    return null
  }

  renderActionsButton = () => {
    const { modalIsSaving, modalData, oikos_id } = this.state
    let status
    if (modalData?.taskStatus_id === undefined || modalData?.taskStatus_id === null)
      status = 0
    else
      status = modalData.taskStatus_id

    switch (status) {
      case 0: return (
        <Button
        type="button"
        color="primary"
        className="waves-effect waves-light"
        disabled={modalIsSaving}
        onClick={() => {
          this.setState(
            {
              modalData: {
                ...modalData,
                taskStatus_id: 1,
              }
            },
            () => { this.handleTaskSubmit() }
          )
        }}
        >
        Atribuir tarefa
        </Button>
      )

      case 1: return modalData.pf_id === oikos_id && (
        <>
        <Button
        type="button"
        color="danger"
        className="waves-effect waves-light"
        disabled={modalIsSaving}
        onClick={() => {
          this.setState(
            {
              modalData: {
                ...modalData,
                taskStatus_id: 2,
              }
            },
            () => { this.handleTaskSubmit() }
          )
          }}
        >
        Recusar tarefa
        </Button>
        <Button
        type="button"
        color="primary"
        className="waves-effect waves-light"
        disabled={modalIsSaving}
        onClick={() => {
          this.setState(
            {
              modalData: {
                ...modalData,
                taskStatus_id: 3,
              }
            },
            () => { this.handleTaskSubmit() }
          )
        }}
        >
        Concluir tarefa
        </Button>
        </>
      )

      case 2: return null

      case 3: return modalData.task_usuarioCria === oikos_id &&  (
        <>
        <Button
        type="button"
        color="danger"
        className="waves-effect waves-light"
        disabled={modalIsSaving}
        onClick={() => {
          this.setState(
            {
              modalData: {
                ...modalData,
                taskStatus_id: 1,
              }
            },
            () => { this.handleTaskSubmit() }
          )
          }}
      >
        Solicitar correção
        </Button>
        <Button
        type="button"
        color="primary"
        className="waves-effect waves-light"
        disabled={modalIsSaving}
        onClick={() => {
          this.setState(
            {
              modalData: {
                ...modalData,
                taskStatus_id: 4,
              }
            },
            () => { this.handleTaskSubmit() }
          )
          }}
        >
        Aprovar tarefa
        </Button>
        </>
      )

      case 4: return null

    }
  }

  renderActionsButtonDataLimite = () => {
    const { modalIsSaving, modalData, oikos_id } = this.state
    if (Number(modalData?.pf_id) !== PF_APROVADOR_DATA_LIMITE) return null
    if (Number(oikos_id) !== PF_APROVADOR_DATA_LIMITE) return null
    if (Number(modalData?.taskStatus_id) !== 1) return null
    return (
      <>
        <Button
          type="button"
          color="danger"
          className="waves-effect waves-light"
          disabled={modalIsSaving}
          onClick={() => {
            if (!String(modalData.task_comentario || '').trim()) {
              notifyError('Escreva um comentário para recusar a alteração da data.')
              return
            }
            this.setState(
              { modalData: { ...modalData, taskStatus_id: 2 } },
              () => { this.handleTaskSubmit() },
            )
          }}
        >
          Recusar data
        </Button>
        <Button
          type="button"
          color="primary"
          className="waves-effect waves-light"
          disabled={modalIsSaving}
          onClick={() => {
            this.setState(
              { modalData: { ...modalData, taskStatus_id: 4 } },
              () => { this.handleTaskSubmit() },
            )
          }}
        >
          Aprovar data
        </Button>
      </>
    )
  }
  renderActionsButtonContrForn = () => {
    const { modalIsSaving, modalData, oikos_id } = this.state
    let status
    if (modalData?.taskStatus_id === undefined || modalData?.taskStatus_id === null)
      status = 0
    else
      status = modalData.taskStatus_id

    return (
      <>
        <Button
        type="button"
        color="danger"
        className="waves-effect waves-light"
        disabled={modalIsSaving}
        onClick={() => {
          this.setState(
            {
              modalData: {
                ...modalData,
                taskStatus_id: 2,
              }
            },
            () => {
              this.handleTaskSubmit();

            }
          )
          }}
        >
        Rejeitar contrato
        </Button>
        <Button
        type="button"
        color="primary"
        className="waves-effect waves-light"
        disabled={modalIsSaving}
        onClick={() => {
          this.setState(
            {
              modalData: {
                ...modalData,
                taskStatus_id: 4,
              }
            },
            () => { this.handleTaskSubmit() }
          )
        }}
        >
        Aprovar contrato
        </Button>
      </>
    )
  }

  renderActionsButtonPedidoCompraOuVaga = () => {
    const { modalIsSaving, modalData, oikos_id } = this.state
    let status
    if (modalData?.taskStatus_id === undefined || modalData?.taskStatus_id === null)
      status = 0
    else
      status = modalData.taskStatus_id

    return (
      <>
        <Button
        type="button"
        color="danger"
        className="waves-effect waves-light"
        disabled={modalIsSaving}
        onClick={() => {
          this.setState(
            {
              modalData: {
                ...modalData,
                taskStatus_id: 2,
              }
            },
            () => {
              this.handleTaskSubmit();

            }
          )
          }}
        >
        Rejeitar
        </Button>
        <Button
        type="button"
        color="primary"
        className="waves-effect waves-light"
        disabled={modalIsSaving}
        onClick={() => {
          this.setState(
            {
              modalData: {
                ...modalData,
                taskStatus_id: 4,
              }
            },
            () => { this.handleTaskSubmit() }
          )
        }}
        >
        Aprovar
        </Button>
      </>
    )
  }

  mailNotification = async (modalData, task_id) => {
    console.log('data que chegou no mailNotification:', modalData)
    const user_in_charge = await getReg('pf', modalData.pf_id)
    const user_author = await getReg('pf', modalData.task_usuarioCria)
    let mail_subject, mail_msg, mail_to
    switch(modalData.taskStatus_id) {
      case 1:
        mail_to = user_in_charge.pf_emailProf
      mail_subject = `Nova tarefa atribuída - ID ${task_id}`
        mail_msg = `Prezado ${user_in_charge.pf_nome}, uma nova tarefa foi atribuída para você por ${user_author.pf_nome}:<br>
        Descrição: ${modalData.task_desc}<br>
        Prazo: ${moment(modalData.task_prazo).format('DD/MM/YYYY')}<br><br>.
        Acesse o <a href="https://oikos.ecoss.is/oikos-client/task">Oikos</a> para visualizá-la e aceitá-la.`
        break
      case 2:
        mail_to = user_author.pf_emailProf
        mail_subject = `Tarefa recusada - ID ${task_id}`
        mail_msg = `Prezado  ${user_author.pf_nome}, a tarefa a seguir foi recusada por ${user_in_charge.pf_nome}:<br>
        Descrição: ${modalData.task_desc}<br>
        Prazo: ${moment(modalData.task_prazo).format('DD/MM/YYYY')}<br><br>.
        Caso esta tarefa ainda seja necessária, será necessário cadastrá-la novamente no <a href="https://oikos.ecoss.is/oikos-client/task">Oikos</a>.`
        break
      case 3:
        mail_to = user_author.pf_emailProf
        mail_subject = `Tarefa concluída - ID ${task_id}`
        mail_msg = `Prezado  ${user_author.pf_nome}, a tarefa a seguir foi marcada como concluída por ${user_in_charge.pf_nome}:<br>
        Descrição: ${modalData.task_desc}<br>
        Prazo: ${moment(modalData.task_prazo).format('DD/MM/YYYY')}<br><br>.
        Acesse o <a href="https://oikos.ecoss.is/oikos-client/task">Oikos</a>, para avaliar o resultado.`
        break
      case 4:
        mail_to = user_in_charge.pf_emailProf
        mail_subject = `Tarefa aprovada - ID ${task_id}`
        mail_msg = `Prezado ${user_in_charge.pf_nome},<br>
        a seguinte tarefa concluída por você, foi aprovada por ${user_author.pf_nome}:<br>
        Descrição: ${modalData.task_desc}<br>
        Prazo: ${moment(modalData.task_prazo).format('DD/MM/YYYY')}<br><br>.
        Acesse o <a href="https://oikos.ecoss.is/oikos-client/task">Oikos</a> para visualizá-la.`
        break
    }
    console.log('mail_to:', mail_to)
    console.log('mail_subject:', mail_subject)
    console.log('mail_msg:', mail_msg)
    console.log('status:', modalData.taskStatus_id)
    sendMail(mail_to, mail_subject, mail_msg)
  }

  renderTaskStatusPill = (status) => {
    switch (status) {
      case 1: return `badge badge-warning` // Pendente
      case 2: return `badge badge-danger` // Recusada
      case 3: return `badge badge-success` // Concluída
      case 4: return `badge badge-info` // Aprovada
    }
  }

  renderTaskAttach = (path, isLoading = false) => {
    if (isLoading && !path) {
      return <Spinner size="sm" />
    }
    if (!path) return null
    return (
      <IconButton onClick={(e) => {
        e.stopPropagation()
        window.open(path, '_blank')
      }}>
        <Description />
      </IconButton>
    )
  }

  formatTaskDate = (value) => {
    if (!value) return '-'
    return moment(value).isValid() ? moment(value).format('DD/MM/YYYY') : '-'
  }

  formatTaskCurrency = (value) => {
    if (value === null || value === undefined || value === '') return '-'
    const numberValue = Number(value)
    if (!Number.isFinite(numberValue)) return '-'
    return numberValue.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    })
  }

  renderDetailItem = (label, value, colSize = 4) => (
    <Col md={colSize} className="mb-2">
      <small className="text-muted d-block">{label}</small>
      <div>{value === null || value === undefined || value === '' ? '-' : value}</div>
    </Col>
  )

  renderPedidoCompraTaskDetails = () => {
    const { modalData, pedidoCompraTaskDetails, isLoadingPedidoCompraTaskDetails } = this.state
    const hasPedidoCompraReference = (modalData.task_tabRef || '').toLowerCase() === 'pedidocompra'
      || ([4, 5].includes(Number(modalData.taskTp_id)) && (modalData.task_tabId || modalData.task_mae))

    if (!modalData.task_id || !hasPedidoCompraReference) return null

    const pedidoCompra = pedidoCompraTaskDetails?.pedidoCompra
    const vaga = pedidoCompraTaskDetails?.vaga

    return (
      <Card className="mb-3">
        <CardBody>
          <h5 className="mb-3">Informações da cotação</h5>
          {isLoadingPedidoCompraTaskDetails ? (
            <div className="d-flex align-items-center">
              <Spinner size="sm" className="mr-2" />
              <span className="text-muted">Carregando informações da cotação...</span>
            </div>
          ) : !pedidoCompra ? (
            <span className="text-muted">Não foi possível localizar a cotação vinculada a esta tarefa.</span>
          ) : (
            <>
              <Row>
                {this.renderDetailItem('Status', pedidoCompra.pedidoCompraStatus_nome || pedidoCompra.compraStatus_nome)}
                {this.renderDetailItem('Responsável', pedidoCompra.pf_nomeExibicao)}
                {this.renderDetailItem('Descrição', pedidoCompra.pedidoCompra_desc, 12)}
                {this.renderDetailItem('Item orçamentário', pedidoCompra.orcItem_desc, 6)}
                {this.renderDetailItem('Valor limite', this.formatTaskCurrency(pedidoCompra.pedidoCompra_vlrLimite), 3)}
                {this.renderDetailItem('Data de solicitação', this.formatTaskDate(pedidoCompra.pedidoCompra_dtSolicitacao), 3)}
                {this.renderDetailItem('Limite de entrega', this.formatTaskDate(pedidoCompra.pedidoCompra_dtLimiteEntrega), 3)}
                {this.renderDetailItem('Início da vigência', this.formatTaskDate(pedidoCompra.pedidoCompra_dtVigIni), 3)}
                {this.renderDetailItem('Fim da vigência', this.formatTaskDate(pedidoCompra.pedidoCompra_dtVigFim), 3)}
              </Row>

              {vaga && (
                <>
                  <hr />
                  <h5 className="mb-3">Informações da vaga</h5>
                  <Row>
                    {this.renderDetailItem('Status', vaga.vagaStatus_nome)}
                    {this.renderDetailItem('Cargo', vaga.vaga_cargo)}
                    {this.renderDetailItem('Descrição', vaga.vaga_descricao, 12)}
                    {this.renderDetailItem('Formação', vaga.vaga_formacao, 6)}
                    {this.renderDetailItem('Tipo de contrato', vaga.vaga_tipoContrato, 3)}
                    {this.renderDetailItem('Salário máximo', this.formatTaskCurrency(vaga.vaga_salarioMaximo), 3)}
                    {this.renderDetailItem('Escopo', vaga.vaga_escopo, 6)}
                    {this.renderDetailItem('Requisitos', vaga.vaga_requisitos, 6)}
                    {this.renderDetailItem('Benefícios', vaga.vaga_beneficios, 6)}
                    {this.renderDetailItem('Documentos obrigatórios', vaga.vagaDocumentosObrigatoriosLabel, 6)}
                  </Row>
                </>
              )}
            </>
          )}
        </CardBody>
      </Card>
    )
  }

  render() {
    const { data1, data2, dataIsLoading, taskAttachmentsLoading, modalIsOpen, modalIsSaving, modalData, switchProj, selPf, selProj, selDpto, selTaskStatus, selTaskTp, oikos_id } = this.state
    const label = { inputProps: { 'aria-label': 'Size switch demo' } };
    const columns1 = [
      {
        accessorKey: 'task_id',
        header: 'ID',
        size: 30,
      },
      {
        accessorKey: 'taskStatus_desc',
        header: 'Status',
        Cell: ({ row }) => <span className={this.renderTaskStatusPill(row.original.taskStatus_id)}>{row.original.taskStatus_desc}</span>,
        size: 50,
        filterVariant: 'multi-select',
      },
      {
        accessorKey: 'task_attach',
        accessorFn: (row) => (row.task_attach ? `https://oikos.ecoss.is/oikos/${row.task_attach}` : null),
        Cell: ({ renderedCellValue, row }) => this.renderTaskAttach(
          renderedCellValue,
          taskAttachmentsLoading && !row.original.task_attach,
        ),
        header: '',
        size: 30,
      },
      {
        accessorKey: 'pf_nome',
        header: 'Autor',
        filterVariant: 'multi-select',
        size: 150,
      },
      {
        accessorKey: 'task_desc',
        header: 'Descrição',
        size: 300,
      },
      {
        id: 'task_prazo',
        accessorKey: 'task_prazo',
        header: 'Prazo',
        accessorFn: (row) => new Date(row.task_prazo),
        sortingFn: 'datetime',
        Cell: ({ cell }) => cell.getValue()?.toLocaleDateString(),
        size: 50,
      },
      {
        accessorKey: 'task_id',
        header: 'ID',
        size: 30,
      },
    ]

    const columns2 = [
      {
        accessorKey: 'task_id',
        header: 'ID',
        size: 30,
      },
      {
        accessorKey: 'taskStatus_desc',
        header: 'Status',
        Cell: ({ row }) => <span className={this.renderTaskStatusPill(row.original.taskStatus_id)}>{row.original.taskStatus_desc}</span>,
        filterVariant: 'multi-select',
        size: 50,
      },
      {
        accessorKey: 'task_attach',
        accessorFn: (row) => (row.task_attach ? `https://oikos.ecoss.is/oikos/${row.task_attach}` : null),
        Cell: ({ renderedCellValue, row }) => this.renderTaskAttach(
          renderedCellValue,
          taskAttachmentsLoading && !row.original.task_attach,
        ),
        header: '',
        size: 30,
      },
      {
        accessorKey: 'pf_nome',
        header: 'Atribuída a',
        filterVariant: 'multi-select',
        size: 150,
      },
      {
        accessorKey: 'task_desc',
        header: 'Descrição',
        maxSize: 300,
      },
      {
        id: 'task_prazo',
        accessorKey: 'task_prazo',
        header: 'Prazo',
        accessorFn: (row) => new Date(row.task_prazo),
        sortingFn: 'datetime',
        Cell: ({ cell }) => cell.getValue()?.toLocaleDateString(),
        size: 50,
      },
    ]

    return (
      <div className="page-content">
        <Modal
          centered
          isOpen={modalIsOpen}
          toggle={() => this.toggleModal()}
          size="xl"
        >
          <ModalHeader toggle={() => this.toggleModal()}>
          {!modalData.task_id && (`Atribuir tarefa`) }
          {modalData.task_id && (`ID ${modalData.task_id} - ${modalData.task_desc}`) }
          </ModalHeader>
          <ModalBody>
            {!modalData.task_id && (
            <FormGroup className="select2-container">
              <Label>Atribuir a</Label>
              <Select
                isMulti
                classNamePrefix="select2-selection"
                placeholder="Selecionar..."
                //value={selPf && selPf?.filter(x => (x.value === modalData.pf_id))}
                options={selPf || []}
                isDisabled={!selPf}
                isLoading={!selPf}
                onChange={e => {
                  this.setState({
                    modalData: {
                      ...modalData,
                      pf_ids: e
                  }})
                  console.log('escolha = ', modalData.pf_ids)
                }}
              />
            </FormGroup>
            )}
            {this.renderPedidoCompraTaskDetails()}
            <FormGroup className="select2-container">
              <Label>Ação</Label>
              <Select
                classNamePrefix="select2-selection"
                placeholder="Selecionar..."
                value={selTaskTp && selTaskTp?.filter(x => (x.value === modalData.taskTp_id))}
                options={selTaskTp || []}
                isDisabled={!selTaskTp || modalData.task_id}
                isLoading={!selTaskTp}
                onChange={e => this.setState({
                  modalData: {
                    ...modalData,
                    taskTp_id: e.value
                  }
                })}
              />
            </FormGroup>
            <FormGroup>
              <Label>Prazo</Label>
              <DatePicker
                locale="pt-BR"
                className="form-control"
                disabled={modalData.task_id !== null && modalData.task_id !== undefined}
                selected={modalData?.task_prazo ? moment(modalData.task_prazo).toDate() : null}
                minDate={new Date()}
                dateFormat="dd/MM/yyyy"
                onChange={date => this.setState({
                  modalData: {
                    ...modalData,
                    task_prazo: date ? moment(date).format('YYYY-MM-DD') : undefined,
                  }
                })}
              />
            </FormGroup>
            <FormGroup className="select2-container">
              <Label>Departamento</Label>
              <Select
                classNamePrefix="select2-selection"
                placeholder="Selecionar..."
                value={selDpto && selDpto?.filter(x => (x.value === modalData.dpto_id))}
                options={selDpto || []}
                isDisabled={!selDpto || modalData.task_id}
                isLoading={!selDpto}
                onChange={e => this.setState({
                  modalData: {
                    ...modalData,
                    dpto_id: e.value
                  }
                })}
              />
            </FormGroup>
            {!modalData.task_id && modalData.dpto_id === 4 && (
            <FormGroup>
              <Switch
                {...label}
                checked={switchProj}
                size="small"
                onChange={() => this.setState({switchProj: !switchProj})}
              />
              <Label>Tarefa vinculada a projeto</Label>
            </FormGroup>)}
            {(switchProj || modalData.proj_id) && (
            <FormGroup className="select2-container">
              <Label>Projeto</Label>
              <Select
                classNamePrefix="select2-selection"
                placeholder="Selecionar..."
                value={selProj && selProj?.filter(x => (x.value === modalData.proj_id))}
                options={selProj || []}
                isDisabled={!selProj || modalData.task_id}
                isLoading={!selProj}
                onChange={e => this.setState({
                  modalData: {
                    ...modalData,
                    proj_id: e.value
                  }
                })}
              />
            </FormGroup> )}
            <FormGroup>
              <Label>Descrição</Label>
              <Input
                className="form-control"
                row={5}
                type="textarea"
                value={modalData.task_desc}
                disabled={modalData.task_id !== null && modalData.task_id !== undefined}
                onChange={e => this.setState({
                  modalData: {
                    ...modalData,
                    task_desc: e.target.value,
                  }
                })}
              />
            </FormGroup>
            {modalData.task_tabRef !== TAB_REF_DATA_LIMITE && (
            <FormGroup>
              <Label>Orientações</Label>
              <Input
                className="form-control"
                row={5}
                type="textarea"
                value={modalData.task_orientacao}
                disabled={modalData.task_id !== null && modalData.task_id !== undefined}
                onChange={e => this.setState({
                  modalData: {
                    ...modalData,
                    task_orientacao: e.target.value,
                  }
                })}
              />
            </FormGroup>
            )}
            <FormGroup>
              <Label>Comentários</Label>
              <Input
                className="form-control"
                row={5}
                type="textarea"
                value={modalData.task_comentario}
                onChange={e => this.setState({
                  modalData: {
                    ...modalData,
                    task_comentario: e.target.value,
                  }
                })}
              />
            </FormGroup>
            {modalData.task_id && false && (
            <FormGroup className="select2-container">
              <Label>Status</Label>
              <Select
                classNamePrefix="select2-selection"
                placeholder="Selecionar..."
                value={selTaskStatus && selTaskStatus?.filter(x => (x.value === modalData.taskStatus_id))}
                options={selTaskStatus || []}
                isDisabled={!selTaskStatus}
                isLoading={!selTaskStatus}
                onChange={e => this.setState({
                  modalData: {
                    ...modalData,
                    taskStatus_id: e.value
                  }
                })}
              />
            </FormGroup>
            )}
            {modalData.task_tabRef !== 'contrForn' &&
            <FormGroup hidden={modalData.task_id && !(modalData.taskStatus_id===1 && modalData.pf_id===oikos_id)}>
              <Label>
                Anexar documento - Tarefa
              </Label>
              <Container>
                <AddFiles
                        drop={false}
                        multiple={false}
                        ref={this.taskFileRef}
                      />
              </Container>
            </FormGroup>
            }
            {!(['contrForn', 'pedidoCompra'].includes(modalData.task_tabRef)) && modalData.task_id && modalData.pf_id === oikos_id && (
            <DocTab refTable='task' refId={modalData.task_mae} />
            )}
            {modalData.task_tabRef && ['contrForn', 'pedidoCompra'].includes(modalData.task_tabRef) &&
              <DocTab refTable={modalData.task_tabRef} refId={modalData.task_tabId} />
            }
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={() => this.toggleModal()}
              color="light"
              className="waves-effect"
              disabled={modalIsSaving}
            >
              Fechar
            </Button>
            {modalData.task_tabRef !== TAB_REF_DATA_LIMITE && ![3, 4, 5].includes(modalData.taskTp_id) && this.renderActionsButton()}
            {modalData.task_tabRef === TAB_REF_DATA_LIMITE && this.renderActionsButtonDataLimite()}
            {modalData.taskTp_id === 3 && this.renderActionsButtonContrForn()}
            {((modalData.taskTp_id === 4) || (modalData.taskTp_id === 5)) && this.renderActionsButtonPedidoCompraOuVaga()}
            {modalIsSaving && (
              <Spinner size="sm" className="ml-2" />
            )}
            {modalData.task_id && modalData.task_usuarioCria === oikos_id && (
              <Button
                type="button"
                color="danger"
                className="waves-effect waves-light"
                disabled={modalIsSaving}
                onClick={() => {
                  this.handleTaskDelete(modalData.task_id)
                }}
              >
              Excluir
              </Button>
            )}
          </ModalFooter>
        </Modal>
        <Container fluid>
          <Row className="mt-2">
            <Col>
              <h3 style={{ marginBottom: 0, paddingBottom: 0 }}>
                Minhas tarefas
              </h3>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <Card>
                <CardBody className="pb-1">
                  {(dataIsLoading || !data1 || oikos_id === 'undefined' || oikos_id === '') && (
                    <div className="pb-3 d-flex align-items-center justify-content-center">
                      <Spinner size="sm" />
                    </div>
                  )}

                  {!dataIsLoading && data1?.length === 0 && oikos_id !== 'undefined' && oikos_id !== '' && (
                    `Você não possui nenhuma tarefa.`
                  )}
                  {!dataIsLoading && data1?.length > 0 && oikos_id !== 'undefined' && oikos_id !== '' && (
                    <MaterialReactTable
                      columns={columns1}
                      data={data1?.filter(x => (x.task_mae !== undefined && x.task_mae !== null && x.task_mae !== ''))}
                      initialState={{
                        density: 'compact',
                        expanded: false, //expand all groups by default
                        pagination: { pageIndex: 0, pageSize: 20 },
                        sorting: [{ id: 'task_prazo', desc: false }], //sort by state by default
                        columnFilters: [{ id: 'taskStatus_desc', value: ['Pendente'] }],
                        hiddenColumns: ['task_id'],
                      }}
                      localization={MRT_Localization_PT}
                      enableFacetedValues
                      enableGrouping
                      enableGlobalFilter
                      enableFilters
                      enablePagination={true}
                      //enableRowActions={true}
                      //clicking anywhere on the row will select it
                      muiTableBodyRowProps={({ row }) => ({
                        onClick: () =>  {
                          const aux_row = row.original
                          this.openTaskModal(aux_row)
                        },
                        sx: { cursor: 'pointer' },
                      })}
                      muiTableBodyCellProps={{
                        sx: {
                          whiteSpace: 'normal',
                          overflowWrap: 'break-word',
                          maxWidth: '300px', // ou qualquer outra largura conforme necessário
                        }
                      }}
                      /*renderRowActions={({ row }) => (
                        <Box>
                          <IconButton onClick= {() => {
                              const aux_row = row.original
                              this.setState({
                                modalData: {
                                  ...aux_row,
                                }
                              })
                              console.log('modalData state = ', this.state.modalData)
                              this.toggleModal()
                            }
                           }>
                            <Edit />
                          </IconButton>
                        </Box>
                      )}*/
                    />
                )}
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row className="mt-2">
            <Col>
              <h3 style={{ marginBottom: 0, paddingBottom: 0 }}>
                Tarefas que atribuí
              </h3>
            </Col>
            <Col style={{ textAlign: 'right' }}>
              <Button
                color="primary"
                type="button"
                onClick={() => {
                  this.setState(
                    {
                      switchProj: false,
                      modalData: {
                        task_usuarioCria: oikos_id,
                        task_usuarioMod: oikos_id,
                      }
                    },
                    this.toggleModal()
                  )
                }}
              >
                Atribuir tarefa
              </Button>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <Card>
                <CardBody className="pb-1">
                  {(dataIsLoading || !data2 || oikos_id === 'undefined' || oikos_id === '') && (
                    <div className="pb-3 d-flex align-items-center justify-content-center">
                      <Spinner size="sm" />
                    </div>
                  )}

                  {!dataIsLoading && data2?.length === 0 && oikos_id !== 'undefined' && oikos_id !== '' && (
                    `Você não atribuiu nenhuma tarefa ainda.`
                  )}

                  {!dataIsLoading && data2?.length > 0 && oikos_id !== 'undefined' && oikos_id !== '' && (
                    <MaterialReactTable
                      columns={columns2}
                      data={data2?.filter(x => (x.task_mae !== undefined && x.task_mae !== null && x.task_mae !== ''))}
                      initialState={{
                        density: 'compact',
                        expanded: false, //expand all groups by default
                        pagination: { pageIndex: 0, pageSize: 20 },
                        sorting: [{ id: 'task_prazo', desc: false }], //sort by state by default
                        columnFilters: [{ id: 'taskStatus_desc', value: ['Pendente'] }],
                      }}
                      enableFacetedValues
                      enableGrouping
                      enableGlobalFilter
                      enableFilters
                      enablePagination={true}
                      //enableRowActions={true}
                      muiTableBodyRowProps={({ row }) => ({
                        onClick: () =>  {
                          const aux_row = row.original
                          this.openTaskModal(aux_row)
                        },
                        sx: { cursor: 'pointer' },
                      })}
                      muiTableBodyCellProps={{
                        sx: {
                          whiteSpace: 'normal',
                          overflowWrap: 'break-word',
                          maxWidth: '300px', // ou qualquer outra largura conforme necessário
                        }
                      }}
                      /*renderRowActions={({ row }) => (
                        <Box>
                          <IconButton onClick= {() => {
                              const aux_row = row.original
                              this.setState({
                                modalData: {
                                  ...aux_row,
                                }
                              })
                              console.log('modalData state = ', this.state.modalData)
                              this.toggleModal()
                            }
                           }>
                            <Edit />
                          </IconButton>
                          <IconButton onClick= {() => {
                              const aux_row = row.original
                              this.handleTaskDelete(aux_row.task_id)
                            }
                           }>
                            <Delete />
                          </IconButton>
                        </Box>
                      )}*/
                    />
                )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )

  }
}

const mapStateToProps = state => ({
  auth: state.auth,
})

export default connect(mapStateToProps)(Task)
